export const HOURS_TYPES = {
  STORE: "STORE",
  THIRD_PARTY: "THIRD_PARTY",
  DELIVERY: "DELIVERY",
};
